export default __webpack_public_path__ + "static/media/Tiger's Gauntlets of the Untamed.d76a2975.jpg";